// removed by extract-text-webpack-plugin
module.exports = {"auth-wrapper":"index__auth-wrapper___3uMyW","auth-wrapper-bg":"index__auth-wrapper-bg___EMk-i","auth-wrapper-logo":"index__auth-wrapper-logo___1u0Fr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/AuthWrapper/index.less
// module id = 1249
// module chunks = 3